
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 210 238">
  <path d="M97 2.6188C101.95 -0.239323 108.05 -0.239323 113 2.6188L201.789 53.8812C206.739 56.7393 209.789 62.0214 209.789 67.7376V170.262C209.789 175.979 206.739 181.261 201.789 184.119L113 235.381C108.05 238.239 101.95 238.239 97 235.381L8.21093 184.119C3.26051 181.261 0.21093 175.979 0.21093 170.262V67.7376C0.21093 62.0214 3.26051 56.7393 8.21093 53.8812L97 2.6188Z"
        fill="#000"
      />
</svg>
